const toggleSettings = (payload) => {
	return {
		type: "toggle_settings",
		payload,
	};
};

const toggleAdditionalSettings = (payload) => {
	return {
		type: "toggle_additional_settings",
		payload,
	};
};

const resetSettings = () => {
	return {
		type: "reset_settings",
	};
};

const resetAllSettings = () => {
	return {
		type: "reset_all_settings",
	};
};

export default {
	toggleSettings,
	resetSettings,
	toggleAdditionalSettings,
	resetAllSettings,
};
